module.exports = require("fast-json-patch");